import React, { Children, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Modal,
  Row,
  Select,
  Spin,
  Table,
} from "antd";

import { notificationErroInternal, notificationSucess } from "util/api-utils";
import {
  getCompanies,
  getIncome,
  getStatus,
} from "services/client/client-service";

import dayjs from "dayjs";
import moment from "moment";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { getBanks } from "services/dashboard/dashboard-service";
import { getBankByClient, getIncomeAdmin } from "services/admin/admin-service";
import { ColumnsIncomeStatementExpend } from "views/client/income-statement/columns-table";
import {
  ColumnsCategoryData,
  ColumnsCategoryDataCompetence,
} from "views/client/cash-flow-client/columns-table-moth";
dayjs.extend(customParseFormat);

const dateFormat = "MM/YYYY";
const { info } = Modal;

const IncomeStatementAdmin = () => {
  const [loadingData, setLoadingData] = useState(false);
  const [data, setData] = useState({ mapping: [], months: [] });
  const [filterStartDate, setStartDate] = useState(moment().format(dateFormat));
  const [filterEndDate, setEndDate] = useState(moment().format(dateFormat));
  const [mapping, setMapping] = useState([]);
  const [banks, setBanks] = useState([]);
  const [filterBanks, setFilterBanks] = useState([]);
  const [status, setStatus] = useState([]);
  const [filterStatus, setFilterStatus] = useState([]);
  const [companyId, setCompanyId] = useState(null);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    getStatus()
      .then((res) => {
        let selectStatus = res.map((obj) => ({
          value: obj.name,
          label: obj.name,
        }));
        let resIdStatus = res.map((item) => item.name);
        setFilterStatus(resIdStatus);
        setStatus(selectStatus);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
    getCompanies()
      .then((res) => {
        res = res.map((obj) => ({
          value: obj.id,
          label: obj.name,
        }));
        setCompanies(res);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }, []);

  function getMappingData(filterStatus, filterBanks) {
    const filter = {
      start: filterStartDate,
      end: filterEndDate,
      status: filterStatus,
      banks: filterBanks,
      companyId: companyId,
    };
    getIncomeAdmin(filter)
      .then((res) => {
        let list = [];

        res.mapping.forEach((item) => {
          list.push({ ...item, isDad: true, showChildren: false });
        });
        setMapping(list);
        setData(res);
        setLoadingData(false);
      })
      .catch((err) => {
        setLoadingData(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const refreshData = () => {
    if (companyId == null) {
      notificationErroInternal("É necessário informar um cliente.");
      return;
    }
    setLoadingData(true);
    if (!filterStatus.includes("Conciliado")) {
      filterStatus.push("Conciliado");
    }
    if (!filterStatus.includes("Quitado")) {
      filterStatus.push("Quitado");
    }
    getMappingData(filterStatus, filterBanks);
  };

  const setFilterStartDate = (e) => {
    if (e == null) {
      setStartDate(moment().format(dateFormat));
    } else {
      setStartDate(e.format(dateFormat));
    }
  };
  const setFilterEndDate = (e) => {
    if (e == null) {
      setEndDate(moment().format(dateFormat));
    } else {
      setEndDate(e.format(dateFormat));
    }
  };

  let keys = data.mapping.map((it) => it.key);
  let size = 800;
  switch (data.months.length) {
    case 4:
      size = 1500;
      break;
    case 5:
      size = 1500;
      break;
    case 6:
      size = 2000;
      break;
    case 7:
      size = 2500;
      break;
    case 8:
      size = 2500;
      break;
    case 9:
      size = 3000;
      break;
    case 10:
      size = 3000;
      break;
    case 11:
      size = 3000;
      break;
    case 12:
      size = 3500;
      break;
    default:
      break;
  }
  const setFilterBank = (e) => {
    if (e.length == 0) {
      let selectBank = banks.map((obj) => obj.value);
      setFilterBanks(selectBank);
    } else {
      setFilterBanks(e);
    }
  };
  const changeFilterStatus = (e) => {
    if (e.length == 0) {
      let statusFilter = status.map((obj) => obj.value);
      setFilterStatus(statusFilter);
    } else {
      setFilterStatus(e);
    }
  };
  const changeClient = (e) => {
    setCompanyId(e);
    getBankByClient(e)
      .then((res) => {
        let selectBank = res.map((obj) => ({
          value: obj.codeAccount,
          label: obj.description,
        }));
        let resIdBank = res.map((item) => item.codeAccount);
        setFilterBanks(resIdBank);
        setBanks(selectBank);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  };
  function showAllCashFlow(data, category) {
    info({
      title: <div style={{ textAlign: "center" }}>Dados de {category}</div>,
      icon: null,
      content: (
        <div style={{ textAlign: "center" }}>
          <Table
            columns={ColumnsCategoryDataCompetence}
            dataSource={data}
            pagination={{ pageSize: 5 }}
            locale={{
              emptyText: "Sem registro",
            }}
          />
        </div>
      ),
      width: "50%",
      centered: true,
      onOk() {},
    });
  }
  const selectPropsBank = {
    mode: "multiple",
    style: {
      width: "100%",
    },
    options: banks,
    onChange: (newValue) => {
      setFilterBank(newValue);
    },
    placeholder: "Selecione o banco",
    maxTagCount: "responsive",
  };

  const selectPropsStatus = {
    mode: "multiple",
    style: {
      width: "100%",
    },
    options: status,
    onChange: (newValue) => {
      changeFilterStatus(newValue);
    },
    placeholder: "Selecione o status",
    maxTagCount: "responsive",
  };
  const showDetails = (key, data, month) => {
    let dataCashFlow = data.allCashflow;
    if (key != "total") {
      dataCashFlow = data.allCashflow.filter(
        (item) => item.dueDate.substring(5, 7) == key
      );
    }

    showAllCashFlow(dataCashFlow, data.category + " - " + month);
  };

  return (
    <div className="container-income">
      <Row gutter={24} style={{ padding: "10px" }}>
        <Col span={24}>
          <Card
            title={"Filtros"}
            bordered={false}
            extra={
              <Button type="primary" onClick={refreshData}>
                Filtrar
              </Button>
            }
          >
            <Form layout={"horizontal"}>
              <Form.Item
                name="startDate"
                style={{ width: "50%" }}
                label="Mês Inicial"
              >
                <DatePicker
                  defaultValue={dayjs(filterStartDate, dateFormat)}
                  format={dateFormat}
                  allowClear={false}
                  style={{ width: "100%" }}
                  picker="month"
                  placeholder="Selecione o mês"
                  onChange={setFilterStartDate}
                />
              </Form.Item>
              <Form.Item
                name="endDate"
                style={{ width: "50%" }}
                label="Mês Final"
              >
                <DatePicker
                  defaultValue={dayjs(filterEndDate, dateFormat)}
                  format={dateFormat}
                  allowClear={false}
                  style={{ width: "100%" }}
                  picker="month"
                  placeholder="Selecione o mês"
                  onChange={setFilterEndDate}
                />
              </Form.Item>
              <Form.Item
                style={{ width: "50%" }}
                name="company"
                label="Cliente"
              >
                <Select
                  style={{ width: "100%" }}
                  options={companies}
                  onChange={changeClient}
                />
              </Form.Item>
              <Form.Item style={{ width: "50%" }} name="banks" label="Bancos">
                <Select {...selectPropsBank} />
              </Form.Item>
              <Form.Item style={{ width: "50%" }} name="status" label="Status">
                <Select {...selectPropsStatus} />
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>

      <div className="card-income"> DRE Gerencial</div>
      <Spin spinning={loadingData} size={"large"}>
        {keys.length > 0 && (
          <Table
            className="table-income"
            pagination={false}
            dataSource={mapping}
            bordered
            rowKey="key"
            size="small"
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  let list = [];
                  data.mapping.forEach((item) => {
                    let showChildren = mapping
                      .filter((key) => key.key == item.key)
                      .map((obj) => obj.showChildren)[0];
                    if (item.key == record.key) {
                      showChildren = !record.showChildren;
                    }
                    list.push({
                      ...item,
                      isDad: true,
                      showChildren: showChildren,
                    });
                    if (showChildren) {
                      item.mapping.forEach((children) => {
                        list.push({
                          ...children,
                          name: children.category,
                          isDad: false,
                          showDetails: showDetails,
                        });
                      });
                    }
                  });

                  setMapping(list);
                }, // click row
              };
            }}
            scroll={{ x: size }}
            columns={ColumnsIncomeStatementExpend(data.months)}
            /* expandable={{
              defaultExpandedRowKeys: keys,
              expandedRowRender: (record) => (
                <Table
                  pagination={false}
                  rowKey="key"
                  showHeader={false}
                  size="small"
                  dataSource={record.mapping}
                  columns={ColumnsIncomeStatementCategoryExpend(data.months)}
                />
              ),
            }}*/
          />
        )}
      </Spin>
    </div>
  );
};
export default IncomeStatementAdmin;
